module.exports = __webpack_public_path__ + "media/payment/unpaid-abc6d043.svg";